import * as styles from './styles.module.css';

const InfoLinks = () => (
  <>
    <h2 className={styles['inquiries__h2']}>Customer Service Inquiries</h2>
    To reach customer service, please{' '}
    <a
      className={styles['inquiries__a']}
      href="https://support.fabfitfun.com/en/articles/44-how-can-i-contact-customer-care"
    >
      click here
    </a>
    <p>&nbsp;</p>
    <h2 className={styles['inquiries__h2']}>Supplier Inquiries</h2>
    Have an amazing company or product and want to work with us? Know of a great brand we should
    work with? Please{' '}
    <a className={styles['inquiries__a']} href="https://fabfitfun.com/suppliers/">
      click here
    </a>
    .<p>&nbsp;</p>
    <h2 className={styles['inquiries__h2']}>Press and Media</h2>
    For media inquiries, please contact{' '}
    <a
      className={styles['inquiries__a']}
      href="mailto:Press@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      press@fabfitfun.com
    </a>
    <p>&nbsp;</p>
    <h2 className={styles['inquiries__h2']}>Marketing and Advertising</h2>
    Have a marketing opportunity?{' '}
    <a
      className={styles['inquiries__a']}
      href="mailto:marketing@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      Email us!
    </a>
    <br />
    Are you an influencer and want to be our partner?{' '}
    <a
      className={styles['inquiries__a']}
      href="mailto:collab@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      Email us!
    </a>
    <br />
    Want to partner, sponsor an event, or advertise with FabFitFun?{' '}
    <a
      className={styles['inquiries__a']}
      href="mailto:advertise@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      Email us!
    </a>
    <p>&nbsp;</p>
    <h2 className={styles['inquiries__h2']}>Reporting Security Issues</h2>
    FabFitFun welcomes collaboration from the security research community. We encourage security
    researchers to work with us to mitigate and coordinate the disclosure of potential security
    vulnerabilities by submitting potential security issues or vulnerability reports to{' '}
    <a
      className={styles['inquiries__a']}
      href="mailto:security_issues@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      security_issues@fabfitfun.com
    </a>{' '}
    for consideration by our externally managed bug bounty program.
    <p>&nbsp;</p>
  </>
);

export default InfoLinks;
